<template>
	<div class="az_action_item">
		<template v-if="activityType === 'CREATE_PROJECT'">
			<i18n data-name="CREATE_PROJECT" tag="p" path="actionItem.CREATE_PROJECT"></i18n>
		</template>

		<template v-else-if="activityType === 'DELETE_PROJECT'">
			<i18n data-name="DELETE_PROJECT" tag="p" path="actionItem.DELETE_PROJECT"></i18n>
		</template>

		<template v-else-if="activityType === 'CHANGE_PROJECT'">
			<i18n data-name="CHANGE_PROJECT" tag="p" path="actionItem.CHANGE_PROJECT">
				<template #oldProName><span class="sh_notification__bold__it">{{ textParams.oldProjectName
						}}</span></template>
				<template #newProName><span class="sh_notification__bold__it">{{ name }}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'INVITE_MEMBER'">
			<i18n data-name="INVITE_MEMBER" tag="p" path="actionItem.INVITE_MEMBER">
				<template #inviteUser><span class="sh_notification__bold__it">{{ textParams.memberName
						}}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'REMOVE_MEMBER'">
			<i18n data-name="REMOVE_MEMBER" tag="p" path="actionItem.REMOVE_MEMBER">
				<template #removeUser><span class="sh_notification__bold__it">{{ textParams.memberName
						}}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'ADD_PROJECT_COLUMN'">
			<i18n data-name="ADD_PROJECT_COLUMN" tag="p" path="actionItem.ADD_PROJECT_COLUMN">
				<template #addProColumn><span class="sh_notification__bold__it">{{ name }}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'UPDATE_PROJECT_COLUMN'">
			<i18n data-name="UPDATE_PROJECT_COLUMN" tag="p" path="actionItem.UPDATE_PROJECT_COLUMN">
				<template #updateNameColumn><span class="sh_notification__bold__it">{{ textParams.oldProjectColumnName
						}}</span></template>
				<template #newNameColumn><span class="sh_notification__bold__it">{{ name }}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'DELETED_PROJECT_COLUMN'">
			<i18n data-name="DELETED_PROJECT_COLUMN" tag="p" path="actionItem.DELETED_PROJECT_COLUMN">
				<template #text><span class="sh_notification__bold__it">{{ name }}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'CREATE_TASK'">
			<i18n data-name="CREATE_TASK" tag="p" path="actionItem.CREATE_TASK">
				<template #column><span class="sh_notification__bold__it">{{ textParams.projectColumnName
						}}</span></template>
				<template #task>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'UPDATE_TASK'">
			<i18n data-name="UPDATE_TASK" tag="p" path="actionItem.UPDATE_TASK">
				<template #oldTask><span class="sh_notification__bold__it">{{ textParams.oldTaskName
						}}</span></template>
				<template #newTask>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'DELETE_TASK'">
			<i18n data-name="DELETE_TASK" tag="p" path="actionItem.DELETE_TASK">
				<template #text><span class="sh_notification__bold__it">{{ name }}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'MOVE_TASK'">
			<i18n data-name="MOVE_TASK" tag="p" path="actionItem.MOVE_TASK">
				<template #task>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
				<template #oldColumn><span class="sh_notification__bold__it">{{
					$t(`${textParams.oldProjectColumnCodeName}`) }}</span></template>
				<template #newColumn><span class="sh_notification__bold__it">{{
					$t(`${textParams.newProjectColumnCodeName}`) }}</span></template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'COPY_TASK'">
			<i18n data-name="COPY_TASK" tag="p" path="actionItem.COPY_TASK">
				<template #oldTask><span class="sh_notification__bold__it">{{ textParams.oldTaskName
						}}</span></template>
				<template #column><span class="sh_notification__bold__it">{{ $t(`${textParams.projectColumnCodeName}`)
						}}</span></template>
				<template #newTask>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else>{{ name }}</template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'JOIN_TASK_MEMBER'">
			<i18n data-name="JOIN_TASK_MEMBER" tag="p" path="actionItem.JOIN_TASK_MEMBER">
				<template #joinMember><span class="sh_notification__bold__it">{{ textParams.memberName
						}}</span></template>
				<template #joinTask>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'REMOVE_TASK_MEMBER'">
			<i18n data-name="REMOVE_TASK_MEMBER" tag="p" path="actionItem.REMOVE_TASK_MEMBER">
				<template #removeUser><span class="sh_notification__bold__it">{{ textParams.memberName
						}}</span></template>
				<template #joinTask>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'CREATE_CHECKLIST_GROUP'">
			<i18n data-name="CREATE_CHECKLIST_GROUP" tag="p" path="actionItem.CREATE_CHECKLIST_GROUP">
				<template #createGroup><span class="sh_notification__bold__it">{{ textParams.checklistGroupName
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'DELETE_CHECKLIST_GROUP'">
			<i18n data-name="DELETE_CHECKLIST_GROUP" tag="p" path="actionItem.DELETE_CHECKLIST_GROUP">
				<template #deleteGroup><span class="sh_notification__bold__it">{{ textParams.checkListGroupName
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'CREATE_CHECKLIST_ITEM'">
			<i18n data-name="CREATE_CHECKLIST_ITEM" tag="p" path="actionItem.CREATE_CHECKLIST_ITEM">
				<template #checkListName><span class="sh_notification__bold__it">{{ textParams.checkListText
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'DELETE_CHECKLIST_ITEM'">
			<i18n data-name="DELETE_CHECKLIST_ITEM" tag="p" path="actionItem.DELETE_CHECKLIST_ITEM">
				<template #checkListText><span class="sh_notification__bold__it">{{ textParams.checkListText
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'COMPLETE_CHECKLIST_ITEM'">
			<i18n data-name="COMPLETE_CHECKLIST_ITEM" tag="p" path="actionItem.COMPLETE_CHECKLIST_ITEM">
				<template #checkListText>{{ textParams.checkListText }}</template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'ADD_COMMENT'">
			<i18n data-name="ADD_COMMENT" tag="p" path="actionItem.ADD_COMMENT">
				<template #addComment><span class="sh_notification__bold__it">{{ textParams.commentText
						}}</span></template>
				<template #addName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'ADD_CHECKLIST'">
			<i18n data-name="ADD_CHECKLIST" tag="p" path="actionItem.ADD_CHECKLIST">
				<template #checkListName><span class="sh_notification__bold__it">{{ textParams.checkListText
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'CHANGE_COMMENT'">
			<i18n data-name="CHANGE_COMMENT" tag="p" path="actionItem.CHANGE_COMMENT">
				<template #changeCommentOld><span class="sh_notification__bold__it">{{ textParams.oldCommentText
						}}</span></template>
				<template #changeCommentNew><span class="sh_notification__bold__it">{{ textParams.newCommentText
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>
		<template v-else-if="activityType === 'UPDATE_TASK_DESCRIPTION'">
			<i18n data-name="UPDATE_TASK_DESCRIPTION" tag="p" path="actionItem.UPDATE_TASK_DESCRIPTION">
				<template #changeDescriptionOld><span class="sh_notification__bold__it">{{ textParams.oldDescription
						}}</span></template>
				<template #changeDescriptionNew><span class="sh_notification__bold__it">{{ textParams.newDescription
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'DELETE_COMMENT'">
			<i18n data-name="DELETE_COMMENT" tag="p" path="actionItem.DELETE_COMMENT">
				<template #deleteComment><span class="sh_notification__bold__it">{{ textParams.commentText
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>
		<template v-else-if="activityType === 'ADD_ATTACHMENT'">
			<i18n data-name="ADD_ATTACHMENT" tag="p" path="actionItem.ADD_ATTACHMENT">
				<template #addAttachment><span class="sh_notification__bold__it">{{ textParams.resourceFileName
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'DELETE_ATTACHMENT'">
			<i18n data-name="DELETE_ATTACHMENT" tag="p" path="actionItem.DELETE_ATTACHMENT">
				<template #deleteAttachment><span class="sh_notification__bold__it">{{ textParams.attachmentName
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'ADD_DUE_DATE'">
			<i18n data-name="ADD_DUE_DATE" tag="p" path="actionItem.ADD_DUE_DATE">
				<template #addDate><span class="sh_notification__bold__it" v-if="textParams[0].deadLine">{{
					textParams[0].deadLine }}</span>
					<span class="sh_notification__bold__it" v-else>{{
						filterTimeDateStr }}</span>
				</template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>




		<!--________________________ ABSENT ACTIVITIES +++ ________________________-->
		<template v-else-if="activityType === 'ARCHIEVE_TASK'">
			<p data-name="ARCHIEVE_TASK"><span class="sh_notification__bold__it">{{ textParams }} {{ '||' }} {{ name
					}}</span></p>
		</template>

		<template v-else-if="activityType === 'LEFT_TASK_MEMBER'">
			<p data-name="LEFT_TASK_MEMBER"><span class="sh_notification__bold__it">{{ textParams }} {{ '||' }} {{ name
					}}</span></p>
		</template>

		<template v-else-if="activityType === 'UPDATE_CHECKLIST_ITEM'">
			<i18n data-name="UPDATE_CHECKLIST_ITEM" tag="p" path="actionItem.UPDATE_CHECKLIST_ITEM">
				<template #deleteAttachment><span class="sh_notification__bold__it">{{ textParams.oldCheckListText
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'UPDATE_CHECKLIST_GROUP'">
			<i18n data-name="UPDATE_CHECKLIST_GROUP" tag="p" path="actionItem.UPDATE_CHECKLIST_GROUP">
				<template #updateOldGrup><span class="sh_notification__bold__it">{{ textParams.oldCheckListGroupName
						}}</span></template>
				<template #updateNewGrup><span class="sh_notification__bold__it">{{ textParams.newCheckListGroupName
						}}</span></template>
				<template #taskName>
					<a href="#" @click.prevent="showModal" v-if="clickable"><span class="sh_notification__bold__it">{{
						name }}</span></a>
					<template v-else><span class="sh_notification__bold__it">{{ name }}</span></template>
				</template>
			</i18n>
		</template>

		<template v-else-if="activityType === 'ADD_ATTACHMENT_COMMENT'">
			<p data-name="ADD_ATTACHMENT_COMMENT"><span class="sh_notification__bold__it">{{ textParams }} {{ '||' }} {{
				name }}</span></p>
		</template>

		<template v-else-if="activityType === 'CHECK_DUE_DATE'">
			<p data-name="CHECK_DUE_DATE"><span class="sh_notification__bold__it">{{ textParams }} {{ '||' }} {{ name
					}}</span></p>
		</template>

		<template v-else-if="activityType === 'UNCHECK_DUE_DATE'">
			<p data-name="UNCHECK_DUE_DATE"><span class="sh_notification__bold__it">{{ textParams }} {{ '||' }} {{ name
					}}</span></p>
		</template>

		<template v-else-if="activityType === 'CONVERT_CHECKLIST_ITEM'">
			<p data-name="CONVERT_CHECKLIST_ITEM"><span class="sh_notification__bold__it">{{ textParams }} {{ '||' }} {{
				name }}</span></p>
		</template>

		<template v-else-if="activityType === 'BACK_ARCHIEVED_TASK'">
			<p data-name="BACK_ARCHIEVED_TASK"><span class="sh_notification__bold__it">{{ textParams }} {{ '||' }} {{
				name }}</span></p>
		</template>
		<!--________________________ ABSENT ACTIVITIES --- ________________________-->


	</div>
</template>
<script>
export default {
	props: {
		action: Object,
		clickable: {
			type: Boolean,
			default: true,
		}
	},
	computed: {
		activityType() {
			if (this.action.activityType) {
				return this.action.activityType.value
			}
			return null;
		},
		textParams() {
			if (this.action.textParams) {
				return JSON.parse(this.action.textParams);
			}
			return {};
		},
		name() {
			return this.action.name
		}
	},
	methods: {
		showModal() {
			this.$store.state.taskModalId = this.action.taskId
		}
	},
}
</script>
<style scoped>
.sh_notification__bold__it {
	position: static;
	font-weight: bold;
	font-style: italic;
	font-size: 14px;
	display: inline;
	margin: 0px;
	width: fit-content;
	word-break: break-word;
	color: #48545D;
}
</style>
